module.exports = __webpack_public_path__ + "static/media/tti_ready@3x.543cb4d8.png";